var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndergroundWaterHole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "m8 44 4-8h4l2-4h6l2 6h6v4h2l6-6h4l4 4 2-6h4l2 10z",
    opacity: 1,
    "data-original": "#dc9600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7800",
    d: "m36 42 6-6h-2l-6 6zM50 40l2-6h-2l-2 6zM12 36l-4 8h2l4-8zM20 32h-2l-2 4h2z",
    opacity: 1,
    "data-original": "#be7800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab400",
    d: "M4 44h56v16H4z",
    opacity: 1,
    "data-original": "#fab400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M4 44h2v16H4z",
    opacity: 1,
    "data-original": "#dc9600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7800",
    d: "M38 56H26a4 4 0 0 1 0-8h12a4 4 0 0 1 0 8zM18 34h4v2h-4zM50 38h2v2h-2z",
    opacity: 1,
    "data-original": "#be7800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64c8f0",
    d: "M38 52v-6l5.586-3.724a.93.93 0 0 0-.93-1.604L40 42v-.764a1.236 1.236 0 0 0-2.342-.553L36 44h-8l-1.658-3.317a1.236 1.236 0 0 0-2.342.553V42l-2.656-1.328a.929.929 0 0 0-.93 1.604L26 46v6z",
    opacity: 1,
    "data-original": "#64c8f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46aad2",
    d: "M16 7a4.993 4.993 0 0 0 4.127 4.912A4.937 4.937 0 0 0 20 13a5 5 0 0 0 5 5 4.908 4.908 0 0 0 3-1.027V52h8V16.973A4.908 4.908 0 0 0 39 18a5 5 0 0 0 5-5c0-.375-.048-.737-.127-1.088A4.993 4.993 0 0 0 48 7z",
    opacity: 1,
    "data-original": "#46aad2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#288cb4",
    d: "M22 13c0-.375.048-.737.127-1.088A4.993 4.993 0 0 1 18 7h-2a4.993 4.993 0 0 0 4.127 4.912A4.937 4.937 0 0 0 20 13a5 5 0 0 0 5 5c.335 0 .657-.043.972-.108A5 5 0 0 1 22 13z",
    opacity: 1,
    "data-original": "#288cb4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64c8f0",
    d: "M12 18v-8a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v8a2 2 0 1 1-4 0V9a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1v9a2 2 0 1 1-4 0z",
    opacity: 1,
    "data-original": "#64c8f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46aad2",
    d: "M50 18V9a1 1 0 0 0-1-1h-2a1 1 0 0 1 1 1v9a2 2 0 0 0 2 2c.366 0 .705-.106 1-.277-.595-.347-1-.985-1-1.723zM14 18v-8a6 6 0 0 1 6-6h-2a6 6 0 0 0-6 6v8a2 2 0 0 0 2 2c.366 0 .705-.106 1-.277-.595-.347-1-.985-1-1.723z",
    opacity: 1,
    "data-original": "#46aad2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64c8f0",
    d: "M15 26a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM49 26a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM51 32a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM13 32a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#64c8f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M10 47.5h2v1h-2zM14 55.5h2v1h-2zM48 47.5h2v1h-2zM44 53.5h2v1h-2z",
    opacity: 1,
    "data-original": "#dc9600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#288cb4",
    d: "M28 16.97h2V52h-2z",
    opacity: 1,
    "data-original": "#288cb4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergroundWaterHole);
export default __webpack_public_path__ + "static/media/undergroundWaterHole.1917ba68b1d0cf90161ad73b8a893f4c.svg";
export { ForwardRef as ReactComponent };